module.exports = "<bulk-bonus-details-page></bulk-bonus-details-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/bulkBonusDetails.html
// module id = 2059
// module chunks = 0